import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress, Divider, SvgIcon, Typography } from '@mui/material';

const Card = ({ icon, title, isLoading, children }) => (
  <Box
    sx={{
      bgcolor: '#FFF',
      border: '1px solid #EFF2F7',
      borderRadius: '6px',
      boxShadow: '0px 9px 16px 0px rgba(159, 162, 191, 0.18)',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <Box sx={{ p: 2.5, display: 'flex', alignItems: 'center' }}>
      <SvgIcon component={icon} sx={{ width: 28, height: 28, color: '#11AEFB' }} />
      <Typography sx={{ fontSize: 20, fontWeight: 500, lineHeight: '20px', color: '#1A2E42', ml: 1.5 }}>
        {title}
      </Typography>
    </Box>
    <Divider variant="fullWidth" />
    {isLoading ? (
      <Box sx={{ height: 200 }} display="flex" alignItems="center" justifyContent="center">
        <CircularProgress />
      </Box>
    ) : (
      <>{children}</>
    )}
  </Box>
);

Card.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.object]),
  title: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default Card;
